module.exports = __webpack_public_path__ + "media/images/pages/chat-f5eb060932557e0323da99f78a1c9a9d.svg";